import { Col, Layout, Row } from 'antd'
import { Outlet } from 'react-router-dom'
import { LayoutFooter } from './components/LayoutFooter'
const { Content } = Layout

export const LayoutOnboarding: React.FC = () => {
  return (
    <Layout style={{ minHeight: '100vh', background: 'white' }}>
      <Content>
        <Row>
          <Col
            className="hide-mobile"
            md={8}
            sm={24}
            style={{
              background: "url('/assets/images/background.png')",
              backgroundSize: 'contain',
              backgroundPosition: 'center',
              height: '100vh',
            }}
          ></Col>
          <Col lg={16} xs={24} sm={24} style={{ height: '100vh' }}>
            <Outlet />
          </Col>
        </Row>
      </Content>
      <LayoutFooter />
    </Layout>
  )
}
